
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqDPm2TZEN_45WCoHL0hSTU27x0eEazOc4B0CV2btku860UMeta } from "/codebuild/output/src1449962431/src/src/pages/faq.vue?macro=true";
import { default as menutp5SJZkQX7G8iHUfT7nCtS8VVdRahVmt4qmhTYnYeiQMeta } from "/codebuild/output/src1449962431/src/src/pages/menu.vue?macro=true";
import { default as indexgnpt8ZQB6JgfsSsjzoAkalYFi6gEDEpTt7EjG7_koEgMeta } from "/codebuild/output/src1449962431/src/src/pages/index.vue?macro=true";
import { default as contacthJrqLB0x1sRltTK4ArawqELU5ZWKGabVrkApIxOLi5YMeta } from "/codebuild/output/src1449962431/src/src/pages/contact.vue?macro=true";
import { default as tutorial6o8PKB8TqEksvq4rZLUOZA8HfLufz1PbGSWwkcUql54Meta } from "/codebuild/output/src1449962431/src/src/pages/tutorial.vue?macro=true";
import { default as agreementiq4iBTTAVDRRuqLFWUlvmXSUkC2MQKCQVYhHViCQJJsMeta } from "/codebuild/output/src1449962431/src/src/pages/agreement.vue?macro=true";
import { default as about_45passCvNUycgBSkhlTwKQXw4HBRbz5mziFJL6yzOZUduG3JAMeta } from "/codebuild/output/src1449962431/src/src/pages/about-pass.vue?macro=true";
import { default as indexVpYRGKZy8ib8nifCTrvZ9n7D9_bS3mDFXt_45NtsmhLcgMeta } from "/codebuild/output/src1449962431/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93R1dZx8HaiXECHmLtayQ8Axntq0CJ8fn8RWxGEcgRVR8Meta } from "/codebuild/output/src1449962431/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenancew0Z2Tce9ftwQHUF0OxAZ56DvkCQRjPDQ9SvN_TxrNscMeta } from "/codebuild/output/src1449962431/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_937oHqHmosUxvqpMBD3GZO82UNNA6fYT0DsBkTppe5qIsMeta } from "/codebuild/output/src1449962431/src/src/pages/notice/[id].vue?macro=true";
import { default as indexmVqJcDEn6RHPzD4doIDo_451yPuFTkCyLlJVSqNOd_VBUMeta } from "/codebuild/output/src1449962431/src/src/pages/coupon/index.vue?macro=true";
import { default as index0sNvJkAKR7Mq7e_454tNsYc8K9_fIIWHOIF_45BwPHx4jSUMeta } from "/codebuild/output/src1449962431/src/src/pages/mypage/index.vue?macro=true";
import { default as indexlECUGBudFqCNH_xWLCnLdkIS4dVZK8I8zkw90skrWCQMeta } from "/codebuild/output/src1449962431/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93wW0lxyLbM_F76C0xJABwx6n5_G5LBNqmeqT48XfofikMeta } from "/codebuild/output/src1449962431/src/src/pages/parking/[id].vue?macro=true";
import { default as indexm2nq2W1lfxk4Tru6wrXkz3ilzhiURh_45KfoiTemiOf_45YMeta } from "/codebuild/output/src1449962431/src/src/pages/history/index.vue?macro=true";
import { default as indexrYhXqbZe_454xzuKj8hEf60OJRUZBZk8VEa_jn_456IcY6gMeta } from "/codebuild/output/src1449962431/src/src/pages/monthly/index.vue?macro=true";
import { default as indexsZBwXnjYQOMG7XGOKqZuuBlOOV4cD1KjIk6ZVmR8s_0Meta } from "/codebuild/output/src1449962431/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexeyftEflabZDvzm18J1tbUTy_45eA_IEByK7jTtz0PvIxsMeta } from "/codebuild/output/src1449962431/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviD_45g7UZNIYwFBn230RBWc180m10uCGpFpCm9wEFaY7LQMeta } from "/codebuild/output/src1449962431/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editsxUuOREJMW3jj93BiilUWirorF2nvtjaJcXjD46wrgIMeta } from "/codebuild/output/src1449962431/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementpZWFE_45rgIWFta1ewfGJzrJbavx8Pp0bqKmLzfjUCdFwMeta } from "/codebuild/output/src1449962431/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexWYTjLbl0oug0Juuemih9NbKEuNoBjsGl03npyVKNYoIMeta } from "/codebuild/output/src1449962431/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dxFN2YHU8nj0Jqfn91f51TBB2dMNFOvks1C6tItQRVvYMeta } from "/codebuild/output/src1449962431/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmJHW789OoYBHUSpHXBQZCZPcMdtb23gkc2Rn_45KYOuJNcMeta } from "/codebuild/output/src1449962431/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexTspziDDwdKO7CVszlv8IvkLSFuIclPSdeONnMTqYXKQMeta } from "/codebuild/output/src1449962431/src/src/pages/card/create/index.vue?macro=true";
import { default as indexRwYsUmFwcaooOs5P8kU9Zy03IRQbLv2voop1Syg8a2gMeta } from "/codebuild/output/src1449962431/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmhQLjGVk3GvS7hvlofFS3S5KKWP5r3SQn76YlxdGaBeIMeta } from "/codebuild/output/src1449962431/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmeV8gK9ECnPPBfC0_45g4b8FV0McQR09taMidTG0e5zF8cMeta } from "/codebuild/output/src1449962431/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completejAMYsMn7ar_Zh6_45jkODgDqtWZpCWUtY2qPDnns5p8ZkMeta } from "/codebuild/output/src1449962431/src/src/pages/membership/complete.vue?macro=true";
import { default as registergturfOrRRUiR_POf45A_45qVXqgvttKWy51dzsdY4h7W8Meta } from "/codebuild/output/src1449962431/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_934SPD7XPnnt7XYiurdZl5cJcURNIRdwmkA_45EizVxIxdcMeta } from "/codebuild/output/src1449962431/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmoFU3_45Sl4_eXYajiXF4uQUpw5yRjRIpNr_B441UWHlOoMeta } from "/codebuild/output/src1449962431/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93gFK5oR_oUW_EZUIE_45CBE6vbtOsQ_45xHTHl8_45Et55cLZgMeta } from "/codebuild/output/src1449962431/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexaqSWSH_6krj6EF3uandiVi1c__SsN981sdIbbleOgQcMeta } from "/codebuild/output/src1449962431/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45code_x_45zHpnmUyMFwgsq6WkfnPib4pLNzQFMFJ728XZuqKwMeta } from "/codebuild/output/src1449962431/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codepz_wdePOKiAjGviJLwo9vMq8iKXZPVCqehsZ2ZOz7QkMeta } from "/codebuild/output/src1449962431/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completel_451XP71mPU8_459w0lraWstmcedz_U70dg6Bfth0QSe88Meta } from "/codebuild/output/src1449962431/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerO7TOgnavIIzc1V3LQdhv26xKR8DUF5_450tdWUrfM6ynIMeta } from "/codebuild/output/src1449962431/src/src/pages/contact-form/register.vue?macro=true";
import { default as completekiQdMDZyuUu59fAM001tzh6oZttDMMzWjhwA_45Szy6zsMeta } from "/codebuild/output/src1449962431/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexlUH3POeSakJ1oao0yNuQWvFXxMgSIuZpQE4Q_450ySgJwMeta } from "/codebuild/output/src1449962431/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmIQ_Ofa_45_XMibaWW9z5M8u5VYMJgYmv4NEGmrNsPz1NsMeta } from "/codebuild/output/src1449962431/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeiklWKxjnO_Ws6fJIMGgGDqLUdN_45t6VwuS0lBsls79UkMeta } from "/codebuild/output/src1449962431/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexBGIzeEIT1HOuzNTy7kiRMwOWPmGnUCWciBWQdbASNCQMeta } from "/codebuild/output/src1449962431/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93gZlzLPuL_6_3pZS_45YynNrq4O4G3H_45Kvy6UGGaxgyGpwMeta } from "/codebuild/output/src1449962431/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completeETzWA6bmiGYcCoMXlYt9JsFWooJ25YPUHWFPNwm17HAMeta } from "/codebuild/output/src1449962431/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasDEUL4NRiC6T2l0E4VvbqGGADgMlyzG8Ox3s_45Rp0kxY4Meta } from "/codebuild/output/src1449962431/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as samplenu5D9Q0k5BVOV3sNm8x1VmrupaLR3g1FoWn3_457_ZJ3QMeta } from "/codebuild/output/src1449962431/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emaildCFRj_455hE6t5qpFJt_45AUU0tJsdHnsfEzlLvI_OccFMsMeta } from "/codebuild/output/src1449962431/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmRiCrxxnr9SapBDPtVaTljJmJ2Bf9fuLz8nU5VCv9WqMMeta } from "/codebuild/output/src1449962431/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentcL7sylNfRK5zhFevOSlaWVZdckp0O_453dj0gufWYE6P8Meta } from "/codebuild/output/src1449962431/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmzl6Cvvdqda3C0SzaVGVuFtWMtgmiwU1BVnMi3fX98j8Meta } from "/codebuild/output/src1449962431/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedatet88xURck4MHYr8839ruVDeWG5Zj6ex4weuADEHkJYYgMeta } from "/codebuild/output/src1449962431/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as complete4opPbqHeGa0hmrzANF53zBUDtrBSZ6_EqrXNi4of8QsMeta } from "/codebuild/output/src1449962431/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeiK2us_45ZcynWUSfLimmk_45gsMhHVsz4__45OBXCU32OXWTMMeta } from "/codebuild/output/src1449962431/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordoCxPqsQ_7A943oKAexAfCcX_45aPcN14lEUCEbrCSjph0Meta } from "/codebuild/output/src1449962431/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasZ_45PTzIfMtm3PkMy64CoJCgqWs6UiwLSYZ_9H5XZcqQIMeta } from "/codebuild/output/src1449962431/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as register1_Ed8Rs7HzF8cPR1luIh73dGwYMqSLxlh9n8LUFJDcIMeta } from "/codebuild/output/src1449962431/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeFwRaf9QPwp5yvr5sS4I7nf_qnzDVOFW_4524165RfAcBIMeta } from "/codebuild/output/src1449962431/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexk2RGrTXkuiYOgQW_I_i5eueokgONays1F6Lrp1O39zYMeta } from "/codebuild/output/src1449962431/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexSqJ2QDL7myHpiF_45w3gX8dz4HF_cG5ECGqovbO9apnrkMeta } from "/codebuild/output/src1449962431/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexP2d7nOT9GSGqkUezVouIEAffKtoOaXNyTHf62O_qx7MMeta } from "/codebuild/output/src1449962431/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexGR2qmtB_3u4hZO5sNhDNEmcOQRWVaIV_yN7crqsqqxYMeta } from "/codebuild/output/src1449962431/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateH3qNEjmxW_45YlsIPiQy4oaptvjuHgD96VDpDJqImpCywMeta } from "/codebuild/output/src1449962431/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completeseyVHMt4N8WVVb6XJeVAKSYimpXsPxPxIj4uzH7E_xcMeta } from "/codebuild/output/src1449962431/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmxaqGBY7kIooQFJnnAViy1oLJr7OT1AmA5MW7HyAh23QMeta } from "/codebuild/output/src1449962431/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexNQaDQb7wRz0f_45pmI3WNz3ss6g1fgo86TpI2k9DWdQPEMeta } from "/codebuild/output/src1449962431/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeJJEFXCqS_45djJ7np2iWlvV0F8jahS2olzl0NdEh8tEhgMeta } from "/codebuild/output/src1449962431/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateryBKMVstzPlya83qi_kfJhKfHSv9RZths_D6zjdOdWkMeta } from "/codebuild/output/src1449962431/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexPC9zs_45Y5gW1_21NKgvho2RO39cWoJpTm4KHMtM9N5DoMeta } from "/codebuild/output/src1449962431/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexIFPSw0uv3ymd1MvlwfIarJAOqNZlaGzHAD7LVCDovqQMeta } from "/codebuild/output/src1449962431/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeZsg52gguq7ljfS4c3J_4cS4A_ndv2__oYN4g5Ots2sUMeta } from "/codebuild/output/src1449962431/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexymMq0REOuyciZZo7A5Xl_45C3v8jhlc_9_45u67osuR6JowMeta } from "/codebuild/output/src1449962431/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codePrhmZdasPEyUgR_SdonQTuTQaWBZjfGtPQvEV2emNDAMeta } from "/codebuild/output/src1449962431/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexNuE_HGoBy3VUyOX0iSjJihvpNa_o9catOyN2bD9K_45fYMeta } from "/codebuild/output/src1449962431/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexFkDzob6cSqxJjsVa_45dhPjtiT9X_nwr5bxSb96xZoaxkMeta } from "/codebuild/output/src1449962431/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexDwsXUpUdm3kiq_wK_SvFaLbjlEVNtRKriuGaxsu7BooMeta } from "/codebuild/output/src1449962431/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as update_45sm0Mk0v0DYPaKu7g_457f9XFo3FxCDHQr1fZ6o5p38SEMeta } from "/codebuild/output/src1449962431/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmzamQYUZN9Nb8QfX2Q4mn14zuYG8M_45sfB6n2jA2uOaCUMeta } from "/codebuild/output/src1449962431/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src1449962431/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menutp5SJZkQX7G8iHUfT7nCtS8VVdRahVmt4qmhTYnYeiQMeta || {},
    component: () => import("/codebuild/output/src1449962431/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indexgnpt8ZQB6JgfsSsjzoAkalYFi6gEDEpTt7EjG7_koEgMeta || {}), ...{"middleware":["search-params"]} },
    component: () => import("/codebuild/output/src1449962431/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src1449962431/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src1449962431/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src1449962431/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src1449962431/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src1449962431/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src1449962431/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src1449962431/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src1449962431/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexmVqJcDEn6RHPzD4doIDo_451yPuFTkCyLlJVSqNOd_VBUMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src1449962431/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src1449962431/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src1449962431/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src1449962431/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexm2nq2W1lfxk4Tru6wrXkz3ilzhiURh_45KfoiTemiOf_45YMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src1449962431/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src1449962431/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexsZBwXnjYQOMG7XGOKqZuuBlOOV4cD1KjIk6ZVmR8s_0Meta || {},
    component: () => import("/codebuild/output/src1449962431/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexeyftEflabZDvzm18J1tbUTy_45eA_IEByK7jTtz0PvIxsMeta || {},
    component: () => import("/codebuild/output/src1449962431/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src1449962431/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1449962431/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src1449962431/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src1449962431/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src1449962431/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1449962431/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexTspziDDwdKO7CVszlv8IvkLSFuIclPSdeONnMTqYXKQMeta || {},
    component: () => import("/codebuild/output/src1449962431/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src1449962431/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmhQLjGVk3GvS7hvlofFS3S5KKWP5r3SQn76YlxdGaBeIMeta || {},
    component: () => import("/codebuild/output/src1449962431/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmeV8gK9ECnPPBfC0_45g4b8FV0McQR09taMidTG0e5zF8cMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src1449962431/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completejAMYsMn7ar_Zh6_45jkODgDqtWZpCWUtY2qPDnns5p8ZkMeta || {},
    component: () => import("/codebuild/output/src1449962431/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registergturfOrRRUiR_POf45A_45qVXqgvttKWy51dzsdY4h7W8Meta || {},
    component: () => import("/codebuild/output/src1449962431/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src1449962431/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmoFU3_45Sl4_eXYajiXF4uQUpw5yRjRIpNr_B441UWHlOoMeta || {},
    component: () => import("/codebuild/output/src1449962431/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src1449962431/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src1449962431/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45code_x_45zHpnmUyMFwgsq6WkfnPib4pLNzQFMFJ728XZuqKwMeta || {},
    component: () => import("/codebuild/output/src1449962431/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codepz_wdePOKiAjGviJLwo9vMq8iKXZPVCqehsZ2ZOz7QkMeta || {},
    component: () => import("/codebuild/output/src1449962431/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completel_451XP71mPU8_459w0lraWstmcedz_U70dg6Bfth0QSe88Meta || {},
    component: () => import("/codebuild/output/src1449962431/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerO7TOgnavIIzc1V3LQdhv26xKR8DUF5_450tdWUrfM6ynIMeta || {},
    component: () => import("/codebuild/output/src1449962431/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src1449962431/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src1449962431/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmIQ_Ofa_45_XMibaWW9z5M8u5VYMJgYmv4NEGmrNsPz1NsMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src1449962431/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeiklWKxjnO_Ws6fJIMGgGDqLUdN_45t6VwuS0lBsls79UkMeta || {},
    component: () => import("/codebuild/output/src1449962431/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexBGIzeEIT1HOuzNTy7kiRMwOWPmGnUCWciBWQdbASNCQMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src1449962431/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src1449962431/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completeETzWA6bmiGYcCoMXlYt9JsFWooJ25YPUHWFPNwm17HAMeta || {},
    component: () => import("/codebuild/output/src1449962431/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1449962431/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(samplenu5D9Q0k5BVOV3sNm8x1VmrupaLR3g1FoWn3_457_ZJ3QMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src1449962431/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emaildCFRj_455hE6t5qpFJt_45AUU0tJsdHnsfEzlLvI_OccFMsMeta || {},
    component: () => import("/codebuild/output/src1449962431/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmRiCrxxnr9SapBDPtVaTljJmJ2Bf9fuLz8nU5VCv9WqMMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1449962431/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentcL7sylNfRK5zhFevOSlaWVZdckp0O_453dj0gufWYE6P8Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1449962431/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmzl6Cvvdqda3C0SzaVGVuFtWMtgmiwU1BVnMi3fX98j8Meta || {},
    component: () => import("/codebuild/output/src1449962431/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src1449962431/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(complete4opPbqHeGa0hmrzANF53zBUDtrBSZ6_EqrXNi4of8QsMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1449962431/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeiK2us_45ZcynWUSfLimmk_45gsMhHVsz4__45OBXCU32OXWTMMeta || {},
    component: () => import("/codebuild/output/src1449962431/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordoCxPqsQ_7A943oKAexAfCcX_45aPcN14lEUCEbrCSjph0Meta || {},
    component: () => import("/codebuild/output/src1449962431/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1449962431/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: register1_Ed8Rs7HzF8cPR1luIh73dGwYMqSLxlh9n8LUFJDcIMeta || {},
    component: () => import("/codebuild/output/src1449962431/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeFwRaf9QPwp5yvr5sS4I7nf_qnzDVOFW_4524165RfAcBIMeta || {},
    component: () => import("/codebuild/output/src1449962431/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src1449962431/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src1449962431/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src1449962431/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src1449962431/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src1449962431/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src1449962431/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src1449962431/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src1449962431/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src1449962431/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src1449962431/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src1449962431/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src1449962431/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src1449962431/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src1449962431/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src1449962431/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src1449962431/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src1449962431/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src1449962431/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src1449962431/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src1449962431/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]